export const tourError = {
    requiredThumbnail: "Vui lòng nhập ảnh thumbnail",
    requiredName: "Vui lòng nhập tên tour",
    requiredSpecificAddress: "Vui lòng nhập địa chỉ cụ thể",
    personValid: "Số người tối đa không hợp lệ",
    numberValid: "Vui lòng nhập số",
    requireSchedule: "Vui lòng nhập tên lịch trình"
}